import {
  CloseIssueMutation,
  CloseIssueMutationVariables,
  IssueFragment,
  ObservationsV1IssueCloseExplanationInput,
  ObservationsV1IssueCloseReason,
  useCloseIssueMutation,
  withStandardMutationHook,
} from '@spotify/confidence-graphql';

export const useCloseIssue = withStandardMutationHook<
  CloseIssueMutation,
  IssueFragment,
  CloseIssueMutationVariables,
  'closeIssue',
  [
    string,
    ObservationsV1IssueCloseReason,
    ObservationsV1IssueCloseExplanationInput?,
  ]
>(
  useCloseIssueMutation,
  'closeIssue',
  (name, closeReason, closeExplanation) => ({
    name,
    closeReason,
    closeExplanation,
  }),
);
